import React from "react";

import { Button } from "shipnow-mercurio";

import { BUYER_FAQS } from "../../constants/links.consts";

export const LandingFAQsButton = () => {
  const handleClick = () => {
    window.open(BUYER_FAQS, "_blank");
  };

  return (
    <Button
      id="acceso_ayuda_comprador_mercurio_iniciar_sesion_ga4"
      margin="t-24"
      onClick={handleClick}
      type="text"
    >
      Ayuda con mi pedido
    </Button>
  );
};
